"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./thread.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class Toolbar extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {};
    this.spacer = /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '32px',
        height: '21px'
      }
    });
  }

  render() {
    const {
      title,
      leftItems,
      rightItems
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "thread-toolbar"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "left-items"
    }, leftItems && leftItems.length ? leftItems : this.spacer), /*#__PURE__*/_react.default.createElement("h1", {
      className: "toolbar-title"
    }, title), /*#__PURE__*/_react.default.createElement("div", {
      className: "right-items"
    }, rightItems && rightItems.length ? rightItems : this.spacer));
  }

}

var _default = Toolbar;
exports.default = _default;